package uz.ferro.erp.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.user.model.User

@Serializable
data class AuthResult(
    val token: String? = null,
    val user: User? = null
)
